.ai-summary-badge {
    font-size: 12px;
    padding: 1px 6px;
    border: 1px solid var(--ai-purple-border);
    background-color: var(--ai-purple-bg);
    color: var(--ai-purple-primary);
    border-radius: 4px;
}
